/**
 * Auth surface for the web app — Carmen's in-house stack.
 *
 * Replaces the former `lib/supabase.ts` mode-dispatch module: since the
 * Supabase decommission (2026-08-24) there is one auth path, so there is no
 * mode to resolve at boot and no supabase-js client to fall back to.
 * Sessions live under `carmen-auth-v2`.
 */
import { carmenAuth } from "./carmenAuth";

export { carmenAuth };

/** The current access token, or null when signed out / unreadable. */
export async function getAccessToken(): Promise<string | null> {
  try {
    const session = await carmenAuth.getSession();
    return session?.access_token ?? null;
  } catch {
    return null;
  }
}

/** Signs out of this device only. */
export async function signOut(): Promise<void> {
  await carmenAuth.signOut({ scope: "local" });
}
